"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectAllExchangeRates = exports.selectExchangeRate = exports.selectCurrentCurrency = exports.selectCurrencies = exports.fetchExchangeRates = exports.exchangeRatesFetched = exports.setCurrency = exports.currencySlice = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var axios_1 = __importDefault(require("axios"));
var CURRENCY_KEY = 'currency';
var CURRENCIES = [
    {
        code: 'amd',
        original: 'Դրամ',
        nameTranslationKey: 'GENERAL.DRAM',
        curSymbol: '֏',
    },
    {
        code: 'usd',
        original: 'USD',
        nameTranslationKey: 'GENERAL.USD',
        curSymbol: '$',
    },
    {
        code: 'rub',
        original: 'Руб',
        nameTranslationKey: 'GENERAL.RUB',
        curSymbol: '₽',
    },
];
var initialState = {
    selected: localStorage.getItem(CURRENCY_KEY) || CURRENCIES[0].code,
    list: CURRENCIES,
    exchangeRates: null,
};
exports.currencySlice = toolkit_1.createSlice({
    name: 'currencies',
    initialState: initialState,
    reducers: {
        setCurrency: function (state, action) {
            localStorage.setItem(CURRENCY_KEY, action.payload);
            state.selected = action.payload;
        },
        exchangeRatesFetched: function (state, action) {
            state.exchangeRates = action.payload;
        },
    },
});
exports.setCurrency = (_a = exports.currencySlice.actions, _a.setCurrency), exports.exchangeRatesFetched = _a.exchangeRatesFetched;
var fetchExchangeRates = function () {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var data, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, axios_1.default.get('/api/exchange-rates')];
                case 1:
                    data = (_a.sent()).data;
                    dispatch(exports.exchangeRatesFetched(data));
                    return [2 /*return*/, data];
                case 2:
                    e_1 = _a.sent();
                    throw e_1;
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
exports.fetchExchangeRates = fetchExchangeRates;
var selectCurrencies = function (state) { return state.currencies.list; };
exports.selectCurrencies = selectCurrencies;
var selectCurrentCurrency = function (state) {
    return state.currencies.selected;
};
exports.selectCurrentCurrency = selectCurrentCurrency;
var selectExchangeRate = function (state) {
    if (!state.currencies.exchangeRates) {
        return;
    }
    var r = state.currencies.exchangeRates.rates[state.currencies.selected.toUpperCase()];
    if (!r) {
        return;
    }
    return parseFloat(r.Rate);
};
exports.selectExchangeRate = selectExchangeRate;
var selectAllExchangeRates = function (state) {
    if (!state.currencies.exchangeRates) {
        return {};
    }
    return state.currencies.exchangeRates.rates;
};
exports.selectAllExchangeRates = selectAllExchangeRates;
exports.default = exports.currencySlice.reducer;
